module.exports = __webpack_public_path__ + "media/images/vehicles/intermediate_audi_a3_4door_lrg-74618016015c1e431c736eaa61415542.jpg";